import {
  Component,
  OnInit,
  Injector,
  ViewChild,
  AfterViewInit,
  ContentChildren
} from "@angular/core";
import { TableAbstractComponent } from "../../../../common-page-components/classes/table-abstract-component";
import { FiltersAthleteGeneralService } from "../../../services/filters-athlete-general.service";
import { AthleteWorldRankingHistory } from "src/app/common-page-components/stores/entities-store/athlete-worldranking-history-store";
import { HttpClient } from "@angular/common/http";
import {
  AthleteCategoriesCombo,
  RangeDateFilterStore
} from "src/app/common-page-components/stores/filters-store/filters-store";
import { combineLatest, Subscription, BehaviorSubject, of, Observable, forkJoin } from "rxjs";
import { map, mergeMap, filter, tap, take, timeout, debounceTime, pairwise } from "rxjs/operators/";
import { OnDestroy, ChangeDetectorRef, ContentChild } from '@angular/core';
import { CategoryCardinalityStruct } from "../../../../library/util/category-cardinality.struct";
import { BreakpointObserver } from "@angular/cdk/layout";
import { ElementRef } from "@angular/core";
import { DateFilterStore } from "../../../../common-page-components/stores/filters-store/filters-store";
import { distinctUntilChanged } from "rxjs/operators";
import { arrayMax } from "../athlete-career-statistics/athlete-career-statistics.component";
import { FiltersAthleteWorldRankingsStatisticsService } from '../../services/filters-athlete-world-rankings-statistics.service';
import { LineChartComponent, Timeline } from '@swimlane/ngx-charts';
import { AthleteBiographyStore } from '../../../../common-page-components/stores/entities-store/athlete-biography-store';
import { CustomLineChartComponent } from '../../../../common-page-components/custom-charts/custom-line-chart/custom-line-chart.component';
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-athlete-world-ranking-statistics",
  templateUrl: "./athlete-world-ranking-statistics.component.html",
  styleUrls: ["./athlete-world-ranking-statistics.component.scss"]
})
export class AthleteWorldRankingStatisticsComponent
  extends TableAbstractComponent
  implements OnInit, OnDestroy, AfterViewInit {
  /**
   * A size of chart for setting it
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  view = [1200, 300];

  /**
   * Custom colors of chart
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  customColors = { domain: ["#0d5c9f", "#dee8f1"] };

  /**
   * View child of chart container
   *
   * @type {ElementRef}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  @ViewChild("chart", { static: false })
  chartContainer: ElementRef;

  /**
   * Range date component
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  rangeDate = new RangeDateFilterStore(
    "range_date",
    new DateFilterStore(
      "from",
      "From",
      undefined,
      undefined,
      new BehaviorSubject({ value: undefined })
    ),
    new DateFilterStore(
      "to",
      "To",
      undefined,
      undefined,
      new BehaviorSubject({ value: new Date() })
    )
  );

  /**
   * chart data property
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  chartData = [];

  /**
   * A property for set the combo category an use with ease
   *
   * @type {AthleteCategoriesCombo}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  comboCategories: AthleteCategoriesCombo = this.worldRankingFilter.categoryComboStats;

  /**
   * A property for set the filters of this page
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  filterInfo = [
    this.comboCategories && this.comboCategories.filterInfo ?
      Object.assign(this.comboCategories.filterInfo, { hideDataCallback: this.common_filter.filterCategoriesWithoutTeam }) : null,
      this.rangeDate.filterInfo
  ].filter(value => value != null);

  /**
   * Property for store the subscription of component and avoid memory leaks
   *
   * @type {Subscription}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  subscription: Subscription;

  /**
   * A value to set the lowest rank in a period
   *
   * @type {number}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  lowestWorldRanking: number;

  /**
   * A property to set the scale of y axis
   *
   * @type {Array<number>}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  chartYPoints: Array<number>;

  /**
   * Chart select directive.
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  @ViewChild('chartSelect', { static: false }) timeline: CustomLineChartComponent = undefined;

  /**
   * Reference to the timeline for avoid overriding to many methods.
   *
   * @type {Observable<Array<Date>>}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  lasTimelineRef: CustomLineChartComponent;

  /**
   * Max date for avoid event propagation when not required on select chart.
   *
   * @type {Date}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  maxDate: Date

  /**
   * Min date for avoid event propagation when not required on select chart.
   *
   * @type {Date}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  minDate: Date

  /**
   * A variable for check if the date has changed without user interaction.
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  autoChangedDate = false;

  /**
   * A method for set the max ranking.
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  maxRanking;

  /**
   *A method for set the actual ranking.
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  actualRanking;

  /**
   *
   *
   * @type {AthleteBiographyStore}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  athleteBiographyStore: AthleteBiographyStore;

  /**
   * A flag for enable the timeline.
   *
   * @type {boolean}
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  timeline_show:boolean = true;
  constructor(
    private break_point: BreakpointObserver,
    protected injector: Injector,
    private common_filter: FiltersAthleteGeneralService,
    private worldRankingFilter: FiltersAthleteWorldRankingsStatisticsService,
    private chg: ChangeDetectorRef,
    private common_service: FiltersAthleteGeneralService,
    protected http_self: HttpClient
  ) {
    super(
      injector,
      common_filter,
      new AthleteWorldRankingHistory(http_self, injector)
    );

  }
  /**
   *
   * @inheritdoc
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  ngOnInit() {
    this.subscriptions.push(
      combineLatest(
        [of(this.comboCategories).pipe(filter(a => a != null), mergeMap(a => a.comboData)),
        this.common_filter.storedId])
        .pipe(
          distinctUntilChanged((a,b) => a[0].Cat === b[0].Cat || b[1] !== a[1]),
          map(([a, b]) => {
          this.athleteBiographyStore = new AthleteBiographyStore(this.http_self, this.injector, b.toString());
          const params = {
            Id: b.toString(),
            Detailed: 1,
            CatCode: a ? (a as any).Cat : undefined,
            CatId:a ? (a as any).CatId : undefined,
            RBP: "ALL",
          };
          // When the category changes.
          return params;
        }),
        // Make two calls, the first one for get the biography store and the second one for get the world ranking history data.
          mergeMap(params => forkJoin([ this.athleteBiographyStore.requestData(params, this.request_more_data),
            this.model.requestData({
              Id:params.Id,
              CatId: params.CatId,
              RBP: 'ALL'
            }, this.request_more_data)
          ])),
          map( ([biographyStore, dataStore])=>{
            if (biographyStore.items[0]) {
              // Set the values in the boxes and calculate the rankings.
              const athlete = biographyStore.items[0];
              this.actualRanking = athlete['WorldRankings']['Current'].length > 0 ? athlete['WorldRankings']['Current'][0] : undefined;
              this.maxRanking = athlete['WorldRankings']['Best'].length > 0 ? athlete['WorldRankings']['Best'][0] : undefined;
            }
            if(dataStore && dataStore.items[0]){
              // Set the filter values and compute the chart.
              const date_to = new Date(dataStore.items[0].RnkDtIssued);
              const date_from = new Date(
                dataStore.items[dataStore.items.length - 1].RnkDtIssued
              );
              this.maxDate = date_to;
              this.minDate = date_from;
              this.rangeDate.filterInfo.options.date_from.min_date = this.minDate;
              this.rangeDate.filterInfo.options.date_from.max_date =this.maxDate;
              this.rangeDate.filterInfo.options.date_to.max_date = this.maxDate;
              this.rangeDate.filterInfo.options.date_to.min_date = this.minDate;
              this.rangeDate.setDates(date_from, date_to);
              this.chartData = this.mapData();
              const ranks = this.chartData[0].series.map(rank => rank.value);
              this.calculateLowestRank(ranks);
              this.calculateStepsOfYAxis(this.lowestWorldRanking);
            }
          }),
        ).subscribe()),
        combineLatest([
          of(this.comboCategories).pipe(filter(a => a != null), mergeMap(a => a.comboData)),
          this.common_filter.storedId,
          this.rangeDate.data.pipe(distinctUntilChanged((x, y) => x.date_to !== y.date_to &&
           x.date_from !== y.date_from)),
        ])
          .pipe(        map(([a, b, c]) => {
              const startDate = (this.autoChangedDate === true) ? this.parseDateToString(this.minDate) :
                this.parseDateToString(c.date_from);
              const endDate = (this.autoChangedDate === true) ? this.parseDateToString(this.maxDate) :
                this.parseDateToString(c.date_to);
              const params = {
                Id: b.toString(),
                CatId: a ? (a as any).CatId : undefined,
                RBP: "ALL",
                Team: a ? ((a as any).isTeam === true ? 1 : 0) : 0,
                //StartDate: startDate,
                //EndDate: endDate
              };
              if(this.lasTimelineRef){
                this.lasTimelineRef.setFilteredDomain(c.date_from, c.date_to)
                this.lasTimelineRef.filteredDomain = [c.date_from, c.date_to];

              }
              return { params: params, domain: this.autoChangedDate };
            }),
            filter(a => {
              return a.params.CatId != undefined;
            }),

            mergeMap((params) => {
              return combineLatest(
                // We check if the date has been auto changed and return one observable or another.
                // This avoid making too many request.
                params.domain === false ? this.model
                  .requestData(params.params, this.request_more_data)
                  .pipe(tap(value => { })) : of(true),
                of(params)).pipe(tap(([next, params]) => {
                  if (next === true) {
                    // if the observable is true and not a object, then function ends.
                    return;
                  }
                }))
            })
          ).subscribe();




  }

  /**
   * Executed for resize of chart to mobile version
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  ngAfterViewInit() {
    this.onResize({ target: { innerWidth: innerWidth } });
    this.chg.detectChanges();
  }

  /**
   * A method for override the set domain function and change dates.
   *
   * @param {Object} object
   * @param {string} method
   * @param {Function} fn
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  overUpdateTimeLineMethod(object: Object, method: string, fn: Function) {
    const originalMethod = object[method];
    const thisRef = this;
    object[method] = function () {
      originalMethod.apply(object, arguments);
      fn.call(object);
      const dates = arguments[0];
      thisRef.autoChangedDate = true;
      thisRef.rangeDate.setDates(dates[0], dates[1]);
      thisRef.autoChangedDate = false;

      const series = object['results'] ? Array.from(object['results'][0]['series']) as Array<{ name: Date, values: number }> : null;
      if (series) {
        const result = series
          .filter((serie) => serie.name > dates[0])
          .filter((serie) => serie.name < dates[1]).map(serie => serie['value']);
        // Perform a calculation for make Y axis responsive.
        thisRef.calculateLowestRank(result);
        thisRef.calculateStepsOfYAxis(thisRef.lowestWorldRanking);
      }
    }
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  ngAfterContentChecked() {
    if (this.timeline) {
      // If chart exist, then we need to compare the reference, because on update or change data the component is destroyed.
      // if this is not done, the function is applied to many times and provokes memory leaks.
      if (this.timeline != this.lasTimelineRef) {
        this.lasTimelineRef = this.timeline;
        this.overUpdateTimeLineMethod(this.timeline, 'updateDomain', () => { });
      }
    }
  }

  /**
   *
   * @inheritdoc
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(value=> value.unsubscribe());
  }

  /**
   * Method for map data into the chart
   *
   * @returns
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  mapData() {
    return this.data && this.data.length > 0
      ? [
        {
          name: "World Ranking",
          series: this.data
            .map(value => {
              return {
                name: new Date(value.RnkDtIssued),
                value: value.Rnk
              };
            })
            .reverse()
        }
      ]
      : [];
  }
  /**
   * A method to calculate the lowest rank of the athlete to fit the chart
   *
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  calculateLowestRank(ranks: Array<number>) {
    this.lowestWorldRanking = arrayMax(ranks) + 5;
  }

  /**
   * A method for calculate the steps of Y axis
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  calculateStepsOfYAxis(lowest_ranking: number) {
    // 5 Steps delimited
    const step = Math.round(lowest_ranking / 5);
    // Plus 1 in the first step for avoid cut the chart
    this.chartYPoints = [step * 5 + 1, step * 4, step * 3, step * 2, 1];
  }

  /**
   * A method to apply resize on chart
   *
   * @param {*} event native DOM event
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  onResize(event) {
    this.view = [
      Math.min(Math.max(event.target.innerWidth / 1.1, 1), 1000),
      400
    ];
  }

  /**
   * Method for avoid decimals in y axis.
   *
   * @param {number} val
   * @returns
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  formatYAxis(val: number) {
    return val.toFixed(0);
  }

  /**
   * Method for get the date and the best ranking.
   *
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  getBestRanking(data: Array<any>) {
    return data.reduceRight((acc, loc) => acc.Rnk < loc.Rnk ? acc : loc);
  }

  /**
   * A helper for parse dates and send as params.
   *
   * @param {Date} date
   * @returns
   * @memberof AthleteWorldRankingStatisticsComponent
   */
  parseDateToString(date: Date) {
    return date ? String(
      new Date(
        date.getTime() -
        date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10)
    ) : undefined;
  }
}
